import { bunja } from 'bunja';
import { atom } from 'jotai';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';

import { updateV2SocketData } from './internal/v2-helper';
import { r230522SocketBunja } from './socket';
import { WsV2OrderbookEvent, WsV2TableEvent } from './types';

type SnapshotOrderbooks = Record<string, Orderbook>;
export type Orderbooks = SnapshotOrderbooks | null;

export interface Orderbook {
  bids: [prcie: string, qty: string][];
  asks: [price: string, qty: string][];
}

function updateOrderbooks(prev: Orderbooks, wsData: WsV2TableEvent<Orderbook>['data']) {
  const prevOrderbooks = prev || {};
  return updateV2SocketData(prevOrderbooks, wsData);
}

const orderbooksAtom = atom<Orderbooks>(null);

export const orderbooksBunja = bunja(() => {
  const { r230522Socket } = bunja.use(r230522SocketBunja);
  const store = bunja.use(JotaiStoreScope);

  let currentOrderbook: string | null = null;

  function updateSubs() {
    r230522Socket.send({ s: { orderBook: currentOrderbook } });
  }

  function setCurrentOrderBook(symbol: string | null = null) {
    const oldSymbool = currentOrderbook;
    currentOrderbook = symbol;
    if (oldSymbool !== symbol) updateSubs();
  }

  bunja.effect(() => {
    updateSubs();

    function handler(event: WsV2OrderbookEvent) {
      if (!event.data) return;
      const symbol = currentOrderbook;
      if (!symbol) return;
      store.set(orderbooksAtom, (prev) => ({ ...prev, [symbol]: event.data }));
    }

    function normalSubHandler(event: WsV2TableEvent<Orderbook>) {
      if (!event.data) return;
      store.set(orderbooksAtom, (prev) => updateOrderbooks(prev, event.data));
    }
    r230522Socket.on('connected', updateSubs);
    r230522Socket.on('market/orderbooks', handler);
    r230522Socket.on('market/orderbooks-v2', normalSubHandler);

    return () => {
      updateSubs();
      r230522Socket.off('connected', updateSubs);
      r230522Socket.off('market/orderbooks', handler);
      r230522Socket.off('market/orderbooks-v2', normalSubHandler);
    };
  });

  return {
    orderbooksAtom,
    setCurrentOrderBook,
  };
});

orderbooksBunja.debugLabel = 'orderbooksBunja';
